import { render } from "./Aggregates.vue?vue&type=template&id=10477ffc"
import script from "./Aggregates.vue?vue&type=script&lang=js"
export * from "./Aggregates.vue?vue&type=script&lang=js"
script.render = render

export default script